import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { type UseModalState } from "@src/lib/ui-react";

interface ConfirmationModalProps {
  modalState: UseModalState;
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
}

export function ConfirmationModal(props: ConfirmationModalProps): JSX.Element {
  const {
    modalState,
    title,
    message,
    confirmText = "Confirm",
    cancelText = "Cancel",
    onConfirm,
  } = props;

  const handleClose = () => {
    modalState.closeModal();
  };

  const handleConfirm = () => {
    onConfirm();
    modalState.closeModal();
  };

  return (
    <Dialog open={modalState.modalIsOpen} onClose={handleClose}>
      {title ? <DialogTitle>{title}</DialogTitle> : null}
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose}>
          {cancelText}
        </Button>
        <Button variant="contained" color="primary" onClick={handleConfirm}>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
